import snackbarUtils from '../snackbarUtils';

const handleCantReserve = (reason: string) => {
  switch (reason) {
    case 'already-has-reservations':
      snackbarUtils.warning('Você já possui reservas.');
      break;
    default:
      snackbarUtils.warning('Não foi possível realizar o agendamento.');
  }
};

export default handleCantReserve;
